import { render, staticRenderFns } from "./PrizesList.vue?vue&type=template&id=9aad79f4&scoped=true&"
import script from "./PrizesList.vue?vue&type=script&lang=ts&"
export * from "./PrizesList.vue?vue&type=script&lang=ts&"
import style0 from "./PrizesList.vue?vue&type=style&index=0&id=9aad79f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aad79f4",
  null
  
)

component.options.__file = "PrizesList.vue"
export default component.exports